import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
} from 'recharts';


class SampleLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      newData: [],
      i: 1,
    }
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

  setWarnings(updatedData) {

    // c2h4 >40 = Overheated Oil
    // CO > 60 = Overheated Cullulose
    // H2 > 60 Partial Discharge in Oil
    // H2 + C2H2 = Arcing in oil

    if (updatedData[0].c2h4 > 40) {
      this.setState({ message: 'Overheated Oil' })     
    } else {
      if (updatedData[0].co > 60) {
        this.setState({ message: 'Overheated Cullulose' })
      } else {
        if (updatedData[0].h2 > 60) {
          this.setState({ message: 'Partial Discharge in Oil' })
        } else {
          if (updatedData[0].C2H2 > 50) {
            this.setState({ message: 'Arcing Oil' })
          } else {
            this.setState({ message: '' })
          }
        }
      }
    }

    if (updatedData[0].co > 50) {
      this.setState({ message: 'Arcing Oil' })
    }

    if (updatedData[0].h2 > 40) {
      this.setState({ message: 'Partial Discharge in Oil' })
    }
  }



    componentDidMount() {

      this.interval = setInterval(() => {

        var updatedData = [{
          date: new Date().toLocaleString(),
          // uv: 18 + Math.round(Math.random() * 2),
          // pv: 23 + Math.round(Math.random() * 4),
          // amt: 21 + Math.round(Math.random() * 3)
          h2: this.getRandomIntInclusive(2.5, 60),
          c2h4: this.getRandomIntInclusive(0.5, 92),
          c2h6: this.getRandomIntInclusive(0.2, 1.5),
          c2h2: this.getRandomIntInclusive(0.5, 0.9),
          co: this.getRandomIntInclusive(5, 64),
          ch4: this.getRandomIntInclusive(0, 9.2)
        }]

        this.setWarnings(updatedData);

        this.setState({
          newData: updatedData, //[...this.state.newData, ...updatedData],
          i: this.state.i + 1,
        })
        console.log(this.state.newData[0].c2h4)
      }, 1000);

    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    renderCustomizedLabel = (props) => {
      const { x, y, width, height, value } = props;
      const radius = 10;

      return (
        <g>
          <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" />
          <text x={x + width / 2} y={y - radius} fill="#fff" textAnchor="middle" dominantBaseline="middle">
            {value.split(' ')[1]}
          </text>
        </g>
      );
    };

    render() {
      return (
        <div style={{ width: '100%' }}>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart
              width={500}
              height={200}
              data={this.state.newData}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="h2" fill="#8884d8" minPointSize={5} />
              <Bar dataKey="c2h4" fill="#82ca9d" minPointSize={10} />
              <Bar dataKey="c2h6" fill="#34ebcc" minPointSize={10} />
              <Bar dataKey="c2h2" fill="#3e6182" minPointSize={10} />
              <Bar dataKey="co" fill="#76823e" minPointSize={10} />
              <Bar dataKey="ch4" fill="#0a36c7" minPointSize={10} />
            </BarChart>
          </ResponsiveContainer>


          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >

            {this.state.message && <p>
              <Alert severity="error">{this.state.message}</Alert>
            </p>}
          </Typography>
        </div>
      );
    }
  }

    export default SampleLineChart;
